import { render, staticRenderFns } from "./treatyPolicy.vue?vue&type=template&id=a45827c6&scoped=true&"
import script from "./treatyPolicy.vue?vue&type=script&lang=js&"
export * from "./treatyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./treatyPolicy.vue?vue&type=style&index=0&id=a45827c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45827c6",
  null
  
)

export default component.exports